import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ProjectGrid from './components/ProjectGrid';
import ProjectPage from './components/ProjectPage';
import Footer from './components/Footer';
import "@/index.css";

function App() {
  const handleResumeClick = () => {
    window.open('https://drive.google.com/file/d/1_4N_O7ChAZVcbfbXJ0ALYU79uGsgg5UL/view?usp=sharing', '_blank');
  };

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background-primary" data-testid="app-container">
        <Header onResumeClick={handleResumeClick} />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <ProjectGrid />
            </main>
          } />
          <Route path="/work/:slug" element={<ProjectPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
